import { render } from "./date-shortcuts.component.vue?vue&type=template&id=0bc8a621&scoped=true&ts=true"
import script from "./date-shortcuts.component.vue?vue&type=script&lang=ts"
export * from "./date-shortcuts.component.vue?vue&type=script&lang=ts"

import "./date-shortcuts.component.vue?vue&type=style&index=0&id=0bc8a621&lang=scss&scoped=true"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc8a621"]])

export default __exports__